// extracted by mini-css-extract-plugin
export default {"page":"EX-z","cartModal":"FX-z","checkout":"GX-z","placeholder":"HX-z","account":"IX-z"};